module.exports = __webpack_public_path__ + "static/media/Avenir-LightOblique.22b9bdb9.woff2";